<script lang="ts">
  import type { HighlightedField } from "../../actions/tooltip";
  import { currencyFormatter } from "../../helpers/localise";
  import { t } from "../../helpers/translations";

  export let invoiceNet: number | undefined = undefined;
  export let invoiceGross: number | undefined = undefined;
  export let creditNoteGross: number | undefined = undefined;
  export let creditNoteNet: number | undefined = undefined;
  export let creditNoteVAT: number | undefined = undefined;
  export let invoiceVAT: number | undefined = undefined;
  export let totalVAT: number | undefined = undefined;
  export let totalNet: number | undefined = undefined;
  export let totalGross: number | undefined = undefined;

  // We use null for cases where we want to explicitly not show the account code section at all
  export let accountNumber: string | undefined | null = undefined;

  export let highlightedField: HighlightedField | undefined = undefined;
  export let x: number = 0;
  export let y: number = 0;

  $: figures = [
    {
      label: t("spend.invoiceNet.label"),
      value: invoiceNet,
      key: "invoiceNet",
    },
    {
      label: t("spend.invoiceTax.label"),
      value: invoiceVAT,
      key: "invoiceVAT",
    },
    {
      label: t("spend.creditNet.label"),
      value: creditNoteNet,
      key: "creditNoteNet",
    },
    {
      label: t("spend.creditTax.label"),
      value: creditNoteVAT,
      key: "creditNoteVAT",
    },
    {
      label: t("spend.invoiceGross.label"),
      value: invoiceGross,
      key: "invoiceGross",
    },
    {
      label: t("spend.creditGross.label"),
      value: creditNoteGross,
      key: "creditNoteGross",
    },
  ].filter((item) => item.value !== undefined);

  $: totals = [
    {
      label: t("spend.totalNet.label"),
      value: totalNet,
      key: "totalNet",
    },
    {
      label: t("spend.totalTax.label"),
      value: totalVAT,
      key: "totalVAT",
    },
    {
      label: t("spend.totalGross.label"),
      value: totalGross,
      key: "totalGross",
    },
  ].filter((item) => item.value !== undefined);
</script>

<div
  class="box"
  style="
		top: {y + 16}px;
		left: {x + 12}px;"
>
  {#if accountNumber !== null}
    <div class="section">
      <div class="row">
        <div>account code</div>
        <div>{accountNumber || "—"}</div>
      </div>
    </div>
    <hr class="divider" />
  {/if}
  <div class="section">
    {#each figures as { label, value }}
      <div class="row">
        <div>{label}</div>
        {#if value != null}
          <div>
            {label.startsWith("credit")
              ? $currencyFormatter.format(-value / 100)
              : $currencyFormatter.format(value / 100)}
          </div>
        {/if}
      </div>
    {/each}
  </div>
  <hr class="divider" />
  <div class="section">
    {#each totals as { label, value, key }}
      <div class="row" class:highlighted={key === highlightedField}>
        <div>{label}</div>
        {#if value != null}
          <div>{$currencyFormatter.format(value / 100)}</div>
        {/if}
      </div>
    {/each}
  </div>
</div>

<style>
  .box {
    position: absolute;
    border-radius: var(--rk-rounding-m);
    background-color: var(--rk-divider-4);
    color: var(--rekki-transparency-light);
    padding: 12px 16px;
    min-width: 225px;
  }

  .highlighted {
    color: var(--rk-text-light);
  }

  .section {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }

  .divider {
    border: 0;
    height: 1px;
    background-color: var(--rekki-neutral-04);
    margin: 12px 0px;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: "DiatypeRekkiTabular";
    font-size: var(--rk-font-size-xs);
    line-height: var(--rk-line-height-xs);
    letter-spacing: -0.5%;
  }
</style>
